import { Image } from '@/components/Image'
import { Link } from '@/components/Link'
import { Typography } from '@/components/Typography'
import { getLinkPathname } from '@/utils/urls'
import styles from './ArticleDetailHeadDay.module.scss'

export type WidgetArticleHeadDayProps = {
  readonly items: Array<{
    readonly id: string
    readonly model: {
      readonly containertype: string
      readonly kicker: string
      readonly publishedAt: string
      readonly author?: {
        readonly image: {
          readonly heightRatio: number
          readonly filename: string
          readonly baseUrl: string
          readonly crop: string
        }
        readonly url?: string
        readonly name?: string
        readonly authorRender?: string
      }
      readonly image: {
        readonly heightRatio: number
        readonly filename: string
        readonly baseUrl: string
        readonly crop: string
      }
      readonly imageAttributes: {
        readonly credit?: string
        readonly title?: string
      }
    }
  }>
}

const WidgetArticleDetailHeadDay = ({ item }: { item: WidgetArticleHeadDayProps }) => (
  <>
    {item.items?.map((item) => {
      const dateObject = new Date(item.model.publishedAt)

      return (
        <div className={styles.day} key={item.id}>
          <div className={styles.title}>{item.model.kicker}</div>
          <div className={styles.date}>
            {dateObject.toLocaleDateString('de-DE', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </div>
        </div>
      )
    })}
  </>
)
export default WidgetArticleDetailHeadDay
